import React, { useState, useCallback, useEffect, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";
import { format, parseISO } from "date-fns";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
	Button,
	IconButton,
	Paper,
	Tooltip,
	Typography,
	CircularProgress,
	Select,
	MenuItem,
	FormControl,
	Chip,
	Switch,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField
} from "@material-ui/core";
import {
	Edit,
	SignalCellularConnectedNoInternet2Bar,
	SignalCellularConnectedNoInternet0Bar,
	SignalCellular4Bar,
	CropFree,
	DeleteOutline,
	PhonelinkSetup,
	AccountTree,
	PhoneIphone,
	WhatsApp as WhatsAppIcon,
	History as HistoryIcon,
	Link as LinkIcon,
	Add as AddIcon,
	Close as CloseIcon,
	Sms as SmsIcon,
	Security as SecurityIcon,
	FileCopyOutlined as CopyIcon
} from "@material-ui/icons";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";

import api from "../../services/api";
import { getBackendUrl, getLinkUrl } from "../../config";
import openSocket from "../../services/socket-io";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import HistoricoQuedasModal from "../../components/HistoricoQuedasModal";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import {
	VERDE,
	bannerNavy,
	bannerTitulo,
	bannerSub,
	bannerStats,
	bannerStat,
	bannerStatValor,
	bannerStatRotulo,
	botaoVidro,
	botaoVerdeBrilho,
	modalPapel,
	modalHero,
	modalHeroLinha,
	modalHeroIcone,
	modalHeroEtiqueta,
	modalHeroTitulo,
	modalHeroSub,
	modalFechar,
	modalCorpo,
	modalSecao,
	modalSecaoTopo,
	modalSecaoIcone,
	modalSecaoTitulo,
	modalSecaoSub,
	modalRodape,
	campoNavy,
	botaoPrimario,
	botaoSecundario
} from "../../utils/estiloNavy";
import {
	situacaoDaConexao,
	exigeAcao,
	formatarNumeroConexao,
} from "../../utils/statusConexao";




const useStyles = makeStyles(theme => ({
	pilulaStatus: {
		display: "inline-flex",
		alignItems: "center",
		gap: 7,
		padding: "4px 12px 4px 10px",
		borderRadius: 20,
		fontSize: "0.78rem",
		fontWeight: 600,
		whiteSpace: "nowrap"
	},
	pontoStatus: {
		width: 8,
		height: 8,
		borderRadius: "50%",
		flexShrink: 0
	},
	
	pontoPulsante: {
		animation: "$pulsar 1.6s infinite"
	},
	"@keyframes pulsar": {
		"0%":   { boxShadow: "0 0 0 0 rgba(229,57,53,0.6)" },
		"70%":  { boxShadow: "0 0 0 7px rgba(229,57,53,0)" },
		"100%": { boxShadow: "0 0 0 0 rgba(229,57,53,0)" }
	},
	banner: {
		...bannerNavy(theme),
		margin: theme.spacing(1, 1, 1.5, 1),
		flexShrink: 0,
	},
	bannerTopo: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		flexWrap: "wrap",
	},
	bannerTitulo,
	bannerSub,
	bannerIcone: {
		width: 40,
		height: 40,
		borderRadius: 12,
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		background: "rgba(255,255,255,.16)",
		boxShadow: "inset 0 0 0 1px rgba(255,255,255,.22)",
	},
	bannerBotoes: { display: "flex", gap: 8, flexWrap: "wrap" },
	bannerStats,
	bannerStat,
	bannerStatValor,
	bannerStatRotulo,
	botaoVidro,
	botaoVerdeBrilho,
	faixaStatus: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		height: 3,
	},
	// modal do link do SMS
	papelLink: modalPapel(theme, 640),
	heroLink: modalHero(theme),
	heroLinha: modalHeroLinha,
	heroIcone: modalHeroIcone,
	heroEtiqueta: modalHeroEtiqueta,
	heroTitulo: modalHeroTitulo,
	heroSub: modalHeroSub,
	fecharModal: { ...modalFechar, marginLeft: "auto", alignSelf: "flex-start" },
	corpoModal: modalCorpo(theme),
	secaoModal: modalSecao(theme),
	secaoTopo: modalSecaoTopo,
	secaoIcone: modalSecaoIcone,
	secaoTitulo: modalSecaoTitulo(theme),
	secaoSub: modalSecaoSub(theme),
	rodapeModal: modalRodape(theme),
	campoNavy: campoNavy(theme),
	btnPrimario: botaoPrimario,
	btnSecundario: botaoSecundario(theme),
	linkCaixa: {
		display: "flex",
		alignItems: "center",
		gap: 8,
		padding: "10px 12px",
		margin: "0 0 14px",
		borderRadius: 12,
		background: theme.palette.type === "dark" ? "rgba(13,148,136,0.10)" : "#effcfa",
		border: "1px dashed rgba(13,148,136,0.4)",
		"& span": {
			flex: 1,
			minWidth: 0,
			fontWeight: 700,
			color: VERDE,
			wordBreak: "break-all",
			fontSize: "0.9rem",
		},
	},
	mainPaper: {
		flex: 1,
		padding: theme.spacing(2),
		margin: theme.spacing(1),
		overflowY: "scroll",
		...theme.scrollbarStyles,
		borderRadius: 18,
		boxShadow: theme.palette.type === "dark"
			? "0 6px 20px rgba(0,0,0,.3)"
			: "0 4px 16px rgba(15,23,42,.05)",
		border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#eef2f6"}`,
		backgroundColor: theme.palette.background.paper,
	},
	customTableCell: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	tableHead: {
		backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.02)" : "#f9fafb",
	},
	tableCellHead: {
		fontWeight: 600,
		color: theme.palette.text.secondary,
		borderBottom: `1px solid ${theme.palette.divider}`,
		textTransform: "uppercase",
		fontSize: "0.75rem",
		letterSpacing: "0.05em",
	},
	tableRow: {
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.03)" : "#f9fafb",
		},
	},
	tableCell: {
		borderBottom: `1px solid ${theme.palette.divider}`,
		padding: "16px",
	},
	actionButton: {
		color: theme.palette.text.secondary,
		"&:hover": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.05)" : "#f3f4f6",
			color: theme.palette.text.primary,
		},
	},
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		fontSize: theme.typography.pxToRem(14),
		border: "1px solid #dadde9",
		maxWidth: 450,
	},
	tooltipPopper: {
		textAlign: "center",
	},
	buttonProgress: {
		color: green[500],
	},
	qrButton: {
		backgroundColor: "#14b8a6",
		color: "#fff",
		fontWeight: 600,
		borderRadius: "8px",
		padding: "6px 16px",
		textTransform: "none",
		boxShadow: "0 4px 6px -1px rgba(20,184,166, 0.4)",
		"&:hover": {
			backgroundColor: "#0d9488",
			boxShadow: "0 6px 8px -1px rgba(20,184,166, 0.5)",
		}
	},
	qrIcon: {
		marginRight: theme.spacing(1),
		fontSize: "1.2rem"
	},
	emptyStateContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(6),
		color: theme.palette.text.secondary,
		backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.01)" : "#fbfbfb",
		borderRadius: "12px",
		border: `1px dashed ${theme.palette.divider}`,
		margin: theme.spacing(2),
	},
	grade: {
		display: "grid",
		gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
		gap: theme.spacing(2),
		padding: theme.spacing(1)
	},
	cartao: {
		position: "relative",
		overflow: "hidden",
		animation: "iaSubir .35s ease backwards",
		borderRadius: 16,
		border: `1px solid ${theme.palette.divider}`,
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2.5),
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2),
		transition: "box-shadow .2s ease, transform .2s ease",
		"&:hover": {
			boxShadow:
				theme.palette.type === "dark"
					? "0 8px 24px rgba(0,0,0,.35)"
					: "0 8px 24px rgba(16,24,40,.08)",
			transform: "translateY(-2px)"
		}
	},
	topoCartao: {
		display: "flex",
		alignItems: "flex-start",
		gap: theme.spacing(1.5)
	},
	selo: {
		width: 46,
		height: 46,
		borderRadius: 12,
		flexShrink: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#fff"
	},
	nomeConexao: {
		fontWeight: 700,
		fontSize: "1.02rem",
		lineHeight: 1.25,
		color: theme.palette.text.primary
	},
	numeroConexao: {
		fontSize: "0.86rem",
		color: theme.palette.text.secondary,
		fontVariantNumeric: "tabular-nums",
		display: "flex",
		alignItems: "center",
		gap: 5,
		marginTop: 2
	},
	numeroVazio: {
		fontSize: "0.86rem",
		color: theme.palette.text.disabled,
		fontStyle: "italic",
		marginTop: 2
	},
	linhaInfo: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		fontSize: "0.78rem",
		color: theme.palette.text.secondary
	},
	rotuloCampo: {
		fontSize: "0.7rem",
		fontWeight: 700,
		textTransform: "uppercase",
		letterSpacing: "0.05em",
		color: theme.palette.text.secondary,
		marginBottom: 6,
		display: "block"
	},
	divisor: {
		height: 1,
		backgroundColor: theme.palette.divider,
		margin: theme.spacing(0.5, 0)
	},
	acoesCartao: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		flexWrap: "wrap"
	},
	botoesSessao: {
		display: "flex",
		gap: theme.spacing(1),
		flexWrap: "wrap"
	},
	flowSelect: {
		width: "100%",
		minWidth: 190,
		"& .MuiSelect-select": {
			paddingTop: 7,
			paddingBottom: 7,
			fontSize: "0.85rem",
			display: "flex",
			alignItems: "center",
			gap: 6,
		},
		"& .MuiOutlinedInput-root": {
			borderRadius: 8,
		}
	}
}));

const CustomToolTip = ({ title, content, children }) => {
	const classes = useStyles();

	return (
		<Tooltip
			arrow
			classes={{
				tooltip: classes.tooltip,
				popper: classes.tooltipPopper,
			}}
			title={
				<React.Fragment>
					<Typography gutterBottom color="inherit">
						{title}
					</Typography>
					{content && <Typography>{content}</Typography>}
				</React.Fragment>
			}
		>
			{children}
		</Tooltip>
	);
};

const Connections = () => {
	const classes = useStyles();
	const { user } = useContext(AuthContext);
	// O operador gerencia as conexoes, mas o Link do SMS e so do admin.
	const ehAdmin = user?.profile === "admin";

	const [whatsAppsList, setWhatsAppsList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [chatbots, setChatbots] = useState([]);
	const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
	const [qrModalOpen, setQrModalOpen] = useState(false);
	const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
	const [confirmModalOpen, setConfirmModalOpen] = useState(false);
	const [updatingFlowId, setUpdatingFlowId] = useState(null);
	// Rodizio do link do SMS: cliques e atendimentos de hoje por conexao.
	const [rodizioStats, setRodizioStats] = useState({});

	const baseDoLink = String(getBackendUrl() || "").replace(/\/+$/, "");
	// Modal do link do SMS: nome do link + mensagem pronta.
	const [modalLinkAberto, setModalLinkAberto] = useState(false);
	const [historicoAberto, setHistoricoAberto] = useState(false);
	const [linkTexto, setLinkTexto] = useState("");
	const [linkSalvo, setLinkSalvo] = useState({ slug: "consigtechpromotora", texto: "", textoFgts: "" });
	const [linkTextoFgts, setLinkTextoFgts] = useState("");
	// Teto de clientes novos por hora, por numero (texto do campo; "" ou 0 = sem teto).
	const [tetoHora, setTetoHora] = useState("");
	const [tetoHoraSalvo, setTetoHoraSalvo] = useState("");
	const [salvandoLink, setSalvandoLink] = useState(false);
	// Com dominio proprio configurado (LINK_URL), o link do SMS e so ele —
	// sem "api." e sem nome no final.
	const dominioDoLink = String(getLinkUrl() || "").replace(/\/+$/, "");
	// Sem o "https://": no SMS sao 8 caracteres a menos e o celular continua
	// deixando o endereco clicavel.
	const linkDoSms = (dominioDoLink || `${baseDoLink}/${linkSalvo.slug}`).replace(
		/^https?:\/\//,
		""
	);
	// Link do FGTS: mesmo rodizio, mensagem do FGTS (o sistema ja marca como FGTS).
	const linkDoSmsFgts = `${(dominioDoLink || baseDoLink).replace(/^https?:\/\//, "")}/fgts`;


	const confirmationModalInitialState = {
		action: "",
		title: "",
		message: "",
		whatsAppId: "",
		open: false,
	};
	const [confirmModalInfo, setConfirmModalInfo] = useState(
		confirmationModalInitialState
	);

	const loadWhatsApps = useCallback(async () => {
		try {
			setLoading(true);
			const { data } = await api.get("/whatsapp");
			setWhatsAppsList(data || []);
		} catch (err) {
			console.error("Erro ao carregar conexoes:", err);
			toastError(err);
		} finally {
			setLoading(false);
		}
	}, []);

	const fetchChatbots = async () => {
		try {
			const { data } = await api.get("/chatbots");
			setChatbots(data || []);
		} catch (err) {
			console.error("Erro ao carregar chatbots:", err);
		}
	};

	useEffect(() => {
		loadWhatsApps();
		fetchChatbots();
	}, [loadWhatsApps]);

	useEffect(() => {
		const socket = openSocket();

		const onWhatsapp = data => {
			if (data.action === "update") {
				setWhatsAppsList(prev => {
					const index = prev.findIndex(s => s.id === data.whatsapp.id);
					if (index !== -1) {
						const updated = [...prev];
						updated[index] = data.whatsapp;
						return updated;
					}
					return [data.whatsapp, ...prev];
				});
			}

			if (data.action === "delete") {
				setWhatsAppsList(prev => prev.filter(s => s.id !== data.whatsappId));
			}
		};
		socket.on("whatsapp", onWhatsapp);

		const onWhatsappsession = data => {
			if (data.action === "update") {
				setWhatsAppsList(prev => {
					const index = prev.findIndex(s => s.id === data.session.id);
					if (index !== -1) {
						const updated = [...prev];
						updated[index] = {
							...updated[index],
							status: data.session.status,
							updatedAt: data.session.updatedAt,
							qrcode: data.session.qrcode,
							retries: data.session.retries,
						};
						return updated;
					}
					return prev;
				});
			}
		};
		socket.on("whatsappSession", onWhatsappsession);

		return () => {
			socket.off("whatsapp", onWhatsapp);
			socket.off("whatsappSession", onWhatsappsession);
		};
	}, []);

	const handleFlowChange = async (whatsAppId, newChatbotId) => {
		setUpdatingFlowId(whatsAppId);
		try {
			await api.put(`/whatsapp/${whatsAppId}`, {
				chatbotId: newChatbotId ? parseInt(newChatbotId) : null,
			});
			setWhatsAppsList(prev =>
				prev.map(w =>
					w.id === whatsAppId
						? { ...w, chatbotId: newChatbotId ? parseInt(newChatbotId) : null }
						: w
				)
			);
			toast.success("Fluxo visual atualizado!");
		} catch (err) {
			toastError(err);
		} finally {
			setUpdatingFlowId(null);
		}
	};

	const handleToggleRodizio = async whatsApp => {
		const vaiEntrar = !whatsApp.rodizioSms;
		setUpdatingFlowId(whatsApp.id);
		try {
			await api.put(`/whatsapp/${whatsApp.id}`, { rodizioSms: vaiEntrar });
			setWhatsAppsList(prev =>
				prev.map(w => (w.id === whatsApp.id ? { ...w, rodizioSms: vaiEntrar } : w))
			);
			toast.success(
				vaiEntrar
					? "Número entrou no rodízio do link do SMS."
					: "Número saiu do rodízio do link do SMS."
			);
		} catch (err) {
			toastError(err);
		} finally {
			setUpdatingFlowId(null);
		}
	};

	const abrirModalLink = async () => {
		setModalLinkAberto(true);
		try {
			const { data } = await api.get("/rodizio-sms/config");
			setLinkTexto(data.texto || "");
			setLinkTextoFgts(data.textoFgts || "");
			setLinkSalvo({ slug: data.slug || "consigtechpromotora", texto: data.texto || "", textoFgts: data.textoFgts || "" });
			const teto = data.tetoHora ? String(data.tetoHora) : "";
			setTetoHora(teto);
			setTetoHoraSalvo(teto);
		} catch (err) {
			toastError(err);
		}
	};

	const salvarLink = async () => {
		setSalvandoLink(true);
		try {
			const { data } = await api.put("/rodizio-sms/config", {
				slug: linkSalvo.slug,
				texto: linkTexto,
				textoFgts: linkTextoFgts,
				tetoHora: Number(tetoHora) || 0
			});
			setLinkSalvo({ slug: data.slug, texto: data.texto, textoFgts: data.textoFgts || "" });
			setLinkTextoFgts(data.textoFgts || "");
			const teto = data.tetoHora ? String(data.tetoHora) : "";
			setTetoHora(teto);
			setTetoHoraSalvo(teto);
			toast.success("Link do SMS salvo.");
		} catch (err) {
			toastError(err);
		} finally {
			setSalvandoLink(false);
		}
	};

	const copiarLinkDoSms = async (qual = "clt") => {
		const link = qual === "fgts" ? linkDoSmsFgts : linkDoSms;
		try {
			await navigator.clipboard.writeText(link);
			toast.success(qual === "fgts" ? "Link do FGTS copiado." : "Link do CLT copiado.");
		} catch (e) {
			toast.info(link);
		}
	};

	const linkAlterado =
		linkTexto !== linkSalvo.texto ||
		linkTextoFgts !== linkSalvo.textoFgts ||
		String(Number(tetoHora) || "") !== String(Number(tetoHoraSalvo) || "");

	const handleToggleAtiva = async whatsApp => {
		const vaiAtivar = whatsApp.ativa === false;
		setUpdatingFlowId(whatsApp.id);
		try {
			await api.put(`/whatsapp/${whatsApp.id}`, { ativa: vaiAtivar });
			setWhatsAppsList(prev =>
				prev.map(w => (w.id === whatsApp.id ? { ...w, ativa: vaiAtivar } : w))
			);
			toast.success(
				vaiAtivar
					? "Número reativado. O sistema vai tentar conectar de novo."
					: "Número inativado. O sistema não vai mais chamá-lo."
			);
		} catch (err) {
			toastError(err);
		} finally {
			setUpdatingFlowId(null);
		}
	};

	const handleStartWhatsAppSession = async whatsAppId => {
		try {
			await api.post(`/whatsappsession/${whatsAppId}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleRequestNewQrCode = async whatsAppId => {
		try {
			await api.put(`/whatsappsession/${whatsAppId}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenWhatsAppModal = () => {
		setSelectedWhatsApp(null);
		setWhatsAppModalOpen(true);
	};

	const handleCloseWhatsAppModal = useCallback(() => {
		setWhatsAppModalOpen(false);
		setSelectedWhatsApp(null);
		loadWhatsApps();
	}, [loadWhatsApps]);

	const handleOpenQrModal = whatsApp => {
		setSelectedWhatsApp(whatsApp);
		setQrModalOpen(true);
	};

	const handleCloseQrModal = useCallback(() => {
		setSelectedWhatsApp(null);
		setQrModalOpen(false);
	}, [setQrModalOpen, setSelectedWhatsApp]);

	const handleEditWhatsApp = whatsApp => {
		setSelectedWhatsApp(whatsApp);
		setWhatsAppModalOpen(true);
	};

	const handleOpenConfirmationModal = (action, whatsAppId) => {
		if (action === "disconnect") {
			setConfirmModalInfo({
				action: action,
				title: i18n.t("connections.confirmationModal.disconnectTitle"),
				message: i18n.t("connections.confirmationModal.disconnectMessage"),
				whatsAppId: whatsAppId,
			});
		}

		if (action === "delete") {
			setConfirmModalInfo({
				action: action,
				title: i18n.t("connections.confirmationModal.deleteTitle"),
				message: i18n.t("connections.confirmationModal.deleteMessage"),
				whatsAppId: whatsAppId,
			});
		}
		setConfirmModalOpen(true);
	};

	const handleSubmitConfirmationModal = async () => {
		if (confirmModalInfo.action === "disconnect") {
			try {
				await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
				loadWhatsApps();
			} catch (err) {
				toastError(err);
			}
		}

		if (confirmModalInfo.action === "delete") {
			try {
				await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
				toast.success(i18n.t("connections.toasts.deleted"));
				loadWhatsApps();
			} catch (err) {
				toastError(err);
			}
		}
		setConfirmModalInfo(confirmationModalInitialState);
	};

	const renderActionButtons = whatsApp => {
		return (
			<>
				{whatsApp.status === "qrcode" && (
					<Button
						size="small"
						variant="contained"
						className={classes.qrButton}
						onClick={() => handleOpenQrModal(whatsApp)}
					>
						<CropFree className={classes.qrIcon} />
						{i18n.t("connections.buttons.qrcode")}
					</Button>
				)}
				{whatsApp.status === "DISCONNECTED" && (
					<>
						<Button
							size="small"
							variant="outlined"
							color="primary"
							onClick={() => handleStartWhatsAppSession(whatsApp.id)}
						>
							{i18n.t("connections.buttons.tryAgain")}
						</Button>
						<Button
							size="small"
							variant="outlined"
							color="secondary"
							onClick={() => handleRequestNewQrCode(whatsApp.id)}
						>
							{i18n.t("connections.buttons.newQr")}
						</Button>
					</>
				)}
				{(whatsApp.status === "CONNECTED" ||
					whatsApp.status === "PAIRING" ||
					whatsApp.status === "TIMEOUT") && (
					<Button
						size="small"
						variant="outlined"
						color="secondary"
						onClick={() => {
							handleOpenConfirmationModal("disconnect", whatsApp.id);
						}}
					>
						{i18n.t("connections.buttons.disconnect")}
					</Button>
				)}
				{whatsApp.status === "OPENING" && (
					<Button size="small" variant="outlined" disabled color="default">
						{i18n.t("connections.buttons.connecting")}
					</Button>
				)}
			</>
		);
	};

	const renderStatusToolTips = whatsApp => {
		const s = situacaoDaConexao(whatsApp.status);
		const pisca = exigeAcao(whatsApp.status);

		return (
			<Tooltip title={s.ajuda} arrow>
				<span
					className={classes.pilulaStatus}
					style={{ backgroundColor: `${s.cor}1F`, color: s.cor }}
				>
					<span
						className={`${classes.pontoStatus} ${pisca ? classes.pontoPulsante : ""}`}
						style={{ backgroundColor: s.cor }}
					/>
					{s.rotulo}
				</span>
			</Tooltip>
		);
	};

	return (
		<MainContainer>
			<ConfirmationModal
				title={confirmModalInfo.title}
				open={confirmModalOpen}
				onClose={setConfirmModalOpen}
				onConfirm={handleSubmitConfirmationModal}
			>
				{confirmModalInfo.message}
			</ConfirmationModal>
			<QrcodeModal
				open={qrModalOpen}
				onClose={handleCloseQrModal}
				whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
			/>
			<WhatsAppModal
				open={whatsAppModalOpen}
				onClose={handleCloseWhatsAppModal}
				whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
			/>
			<HistoricoQuedasModal open={historicoAberto} onClose={() => setHistoricoAberto(false)} />
			<div className={classes.banner}>
				<div className={classes.bannerTopo}>
					<div>
						<div className={classes.bannerTitulo}>
							<span className={classes.bannerIcone}>
								<WhatsAppIcon />
							</span>
							Conexões
						</div>
						<div className={classes.bannerSub}>
							Números de WhatsApp que atendem os candidatos e o fluxo visual de cada um.
						</div>
					</div>
					<div className={classes.bannerBotoes}>
						<Button className={classes.botaoVidro} startIcon={<HistoryIcon />} onClick={() => setHistoricoAberto(true)}>
							Histórico de quedas
						</Button>
						<Button className={classes.botaoVerdeBrilho} startIcon={<AddIcon />} onClick={handleOpenWhatsAppModal}>
							{i18n.t("connections.buttons.add")}
						</Button>
					</div>
				</div>
				{(() => {
					const lista = whatsAppsList || [];
					const ativas = lista.filter(w => w.ativa !== false);
					const conectadas = ativas.filter(w => w.status === "CONNECTED").length;
					const fora = ativas.length - conectadas;
					const inativas = lista.length - ativas.length;
					return (
						<div className={classes.bannerStats}>
							{[
								{ v: conectadas, r: "Conectadas", c: "#2dd4bf" },
								{ v: fora, r: "Fora do ar", c: fora ? "#fbbf24" : "#64748b" },
								{ v: inativas, r: "Inativas", c: "#94a3b8" }
							].map((x, i) => (
								<div key={x.r} className={classes.bannerStat} style={{ animationDelay: `${i * 60}ms` }}>
									<div className={classes.bannerStatValor}>{x.v}</div>
									<div className={classes.bannerStatRotulo}>
										<span style={{ width: 7, height: 7, borderRadius: "50%", background: x.c }} />
										{x.r}
									</div>
								</div>
							))}
						</div>
					);
				})()}
			</div>
			<Paper className={classes.mainPaper} variant="outlined">
				{loading && (
					<div className={classes.emptyStateContainer}>
						<CircularProgress size={30} className={classes.buttonProgress} />
					</div>
				)}

				{!loading && whatsAppsList?.length === 0 && (
					<div className={classes.emptyStateContainer}>
						<PhonelinkSetup style={{ fontSize: 64, color: "#9ca3af", marginBottom: 16 }} />
						<Typography variant="h6" style={{ color: "#4b5563", fontWeight: 600 }}>
							Nenhuma conexão encontrada
						</Typography>
						<Typography variant="body2" style={{ color: "#6b7280", marginTop: 8, maxWidth: 400 }}>
							Você ainda não conectou nenhum WhatsApp. Clique no botão "Adicionar
							WhatsApp" no canto superior direito para começar.
						</Typography>
					</div>
				)}

				{!loading && whatsAppsList?.length > 0 && (
					<div className={classes.grade}>
						{whatsAppsList.map(whatsApp => {
							const inativa = whatsApp.ativa === false;
							// Numero inativo nao tem "status" que interesse: ele nao esta
							// tentando conectar. Mostrar "Desconectado" em vermelho daria a
							// entender que ha algo a consertar.
							const s = inativa
								? { rotulo: "Inativo", cor: "#667085", ajuda: "O sistema não tenta conectar nem envia por este número." }
								: situacaoDaConexao(whatsApp.status);
							const numero = formatarNumeroConexao(whatsApp.numero);

							return (
								<div
									key={whatsApp.id}
									className={classes.cartao}
									style={inativa ? { opacity: 0.62 } : {}}
								>
									<span className={classes.faixaStatus} style={{ background: `linear-gradient(90deg, ${s.cor}, ${s.cor}55)` }} />
									{/* topo: identidade da conexão */}
									<div className={classes.topoCartao}>
										<div
											className={classes.selo}
											style={{
												background: `linear-gradient(135deg, ${s.cor} 0%, ${s.cor}CC 100%)`
											}}
										>
											<WhatsAppIcon style={{ fontSize: 26 }} />
										</div>

										<div style={{ flex: 1, minWidth: 0 }}>
											<Typography className={classes.nomeConexao} noWrap>
												{whatsApp.name}
											</Typography>
											{numero ? (
												<Tooltip title="Número logado nesta conexão" arrow>
													<span className={classes.numeroConexao}>
														<PhoneIphone style={{ fontSize: 15 }} />
														{numero}
													</span>
												</Tooltip>
											) : (
												<span className={classes.numeroVazio}>
													Número aparece após conectar
												</span>
											)}
										</div>

										<div style={{ display: "flex", alignItems: "center", gap: 2 }}>
											<Tooltip
												arrow
												title={
													inativa
														? "Número inativo — clique para reativar"
														: "Número ativo — clique para inativar (banido, chip trocado...)"
												}
											>
												<Switch
													size="small"
													color="primary"
													checked={!inativa}
													disabled={updatingFlowId === whatsApp.id}
													onChange={() => handleToggleAtiva(whatsApp)}
												/>
											</Tooltip>
											<Tooltip title="Editar" arrow>
												<IconButton
													size="small"
													className={classes.actionButton}
													onClick={() => handleEditWhatsApp(whatsApp)}
												>
													<Edit fontSize="small" />
												</IconButton>
											</Tooltip>
											<Tooltip title="Excluir" arrow>
												<IconButton
													size="small"
													className={classes.actionButton}
													onClick={() =>
														handleOpenConfirmationModal("delete", whatsApp.id)
													}
												>
													<DeleteOutline fontSize="small" />
												</IconButton>
											</Tooltip>
										</div>
									</div>

									<div className={classes.divisor} />

									{/* status + última atualização */}
									<div className={classes.linhaInfo}>
										{inativa ? (
											<Tooltip title={s.ajuda} arrow>
												<span
													className={classes.pilulaStatus}
													style={{ backgroundColor: `${s.cor}1F`, color: s.cor }}
												>
													<span
														className={classes.pontoStatus}
														style={{ backgroundColor: s.cor }}
													/>
													Inativo
												</span>
											</Tooltip>
										) : (
											renderStatusToolTips(whatsApp)
										)}
										<span>
											Atualizado {format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}
										</span>
									</div>

									{/* fluxo visual */}
									<div>
										<span className={classes.rotuloCampo}>Fluxo visual</span>
										<FormControl
											variant="outlined"
											size="small"
											className={classes.flowSelect}
										>
											<Select
												MenuProps={{
													getContentAnchorEl: null,
													anchorOrigin: { vertical: "bottom", horizontal: "left" },
													transformOrigin: { vertical: "top", horizontal: "left" }
												}}
												value={whatsApp.chatbotId || ""}
												disabled={updatingFlowId === whatsApp.id}
												onChange={e => handleFlowChange(whatsApp.id, e.target.value)}
												displayEmpty
											>
												<MenuItem value="">
													<em>Nenhum (Atendimento Humano)</em>
												</MenuItem>
												{chatbots.map(cb => {
													const noAr = whatsAppsList.filter(
														x => x.chatbotId === cb.id && x.ativa !== false && x.status === "CONNECTED"
													).length;
													return (
														<MenuItem key={cb.id} value={cb.id} style={{ gap: 8 }}>
															<AccountTree style={{ fontSize: 16, color: "#0D9488" }} />
															<span style={{ flex: 1 }}>{cb.name}</span>
															<span
																style={{
																	fontSize: 10.5,
																	fontWeight: 700,
																	color: noAr ? "#0D9488" : "#94a3b8",
																	background: noAr ? "rgba(13,148,136,0.12)" : "rgba(148,163,184,0.15)",
																	borderRadius: 999,
																	padding: "1px 7px"
																}}
															>
																{noAr} no ar
															</span>
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
										{whatsApp.chatbotId && !inativa && whatsApp.status !== "CONNECTED" && (
											<Typography
												variant="caption"
												style={{ display: "block", marginTop: 4, color: "#d97706", fontWeight: 600 }}
											>
												Fora do fluxo enquanto estiver desconectado — volta sozinho ao reconectar.
											</Typography>
										)}
									</div>

									{/* ações de sessão (QR, desconectar, tentar novamente...) */}
									<div className={classes.acoesCartao}>
										<div className={classes.botoesSessao}>
											{inativa ? (
												<Typography variant="caption" color="textSecondary">
													Conversas deste número continuam por outra conexão.
												</Typography>
											) : (
												renderActionButtons(whatsApp)
											)}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				)}
			</Paper>
		</MainContainer>
	);
};

export default Connections;
